module.exports = __webpack_public_path__ + "static/img/right-num-row-6.02163ce8.png";